import { render, staticRenderFns } from "./CopyableText.vue?vue&type=template&id=da937060&scoped=true&"
import script from "./CopyableText.vue?vue&type=script&lang=ts&"
export * from "./CopyableText.vue?vue&type=script&lang=ts&"
import style0 from "./CopyableText.vue?vue&type=style&index=0&id=da937060&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da937060",
  null
  
)

export default component.exports
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTooltip});
